<template>
  <div id="register-form" class="apple-auth-card">

    <!-- SECTION: LOGIN -->
    <div v-if="type === 'login'" class="auth-section">
      <div class="brand-header text-center">
        <a href="/" class="d-inline-block">
          <b-img :src="logoPath" fluid width="130" alt="Coressy"></b-img>
        </a>
        <h2 class="auth-title">Autentificare</h2>
        <p class="auth-subtitle">Introdu datele tale pentru a intra în cont</p>
      </div>

      <form autocomplete="off" @submit.prevent="login">
        <div class="custom-form-group">
          <label class="input-label">E-Mail</label>
          <b-input
              type="email"
              v-model="email"
              placeholder="nume@domeniu.ro"
              class="custom-input"
          ></b-input>
        </div>

        <div class="custom-form-group">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <label class="input-label mb-0">Parolă</label>
            <b-link @click="type = 'reset'" class="forgot-link">Ai uitat parola?</b-link>
          </div>
          <div class="password-wrapper">
            <b-input
                :type="passwordType"
                v-model="password"
                placeholder="••••••••"
                class="custom-input pr-5"
            ></b-input>
            <button
                type="button"
                class="btn-toggle-password"
                @click="togglePassword"
            >
              {{ passwordType === 'password' ? 'Afișează' : 'Ascunde' }}
            </button>
          </div>
        </div>

        <div class="action-container mt-4">
          <b-button type="submit" class="btn-apple-primary">
            Intră în cont
          </b-button>
        </div>

        <div class="switch-mode-text text-center mt-3">
          Nu ai cont?
          <b-link @click="type = 'register'" class="accent-link">Înregistrează-te</b-link>
        </div>
      </form>

      <div class="divider"><span>sau</span></div>

      <div class="facebook-wrapper">
        <v-facebook-login
            style="width: 100%"
            v-model="fbModel"
            @sdk-init="handleSdkInit"
            app-id="561999889750861"
            @login="getUserData"
            @logout="logout"
            class="custom-fb-btn"
        >
          <span slot="login">Autentificare cu Facebook</span>
          <span slot="working">Se procesează...</span>
        </v-facebook-login>
      </div>
    </div>

    <!-- SECTION: REGISTER -->
    <div v-if="type === 'register'" class="auth-section">
      <div class="brand-header text-center">
        <a href="/" class="d-inline-block">
          <b-img :src="logoPath" fluid width="130" alt="Coressy"></b-img>
        </a>
        <h2 class="auth-title">Creează un cont</h2>
        <p class="auth-subtitle">Completează datele de mai jos pentru înregistrare</p>
      </div>

      <form autocomplete="off" @submit.prevent="register">
        <div class="form-row-double">
          <div class="custom-form-group">
            <label class="input-label">Nume *</label>
            <b-input type="text" v-model="lastName" placeholder="Popescu" class="custom-input"></b-input>
          </div>
          <div class="custom-form-group">
            <label class="input-label">Prenume *</label>
            <b-input type="text" v-model="firstName" placeholder="Andrei" class="custom-input"></b-input>
          </div>
        </div>

        <div class="custom-form-group">
          <label class="input-label">Email *</label>
          <b-input type="email" v-model="email" placeholder="nume@domeniu.ro" class="custom-input"></b-input>
        </div>

        <div class="custom-form-group">
          <label class="input-label">Parolă *</label>
          <b-input type="password" v-model="password" placeholder="••••••••" class="custom-input"></b-input>
        </div>

        <div class="custom-form-group">
          <label class="input-label">Confirmare Parolă *</label>
          <b-input type="password" v-model="c_password" placeholder="••••••••" class="custom-input"></b-input>
        </div>

        <div class="action-container mt-4">
          <b-button type="submit" class="btn-apple-primary">
            Creează Contul
          </b-button>
        </div>

        <div class="switch-mode-text text-center mt-3">
          Ești deja client?
          <b-link @click="type = 'login'" class="accent-link">Autentifică-te</b-link>
        </div>
      </form>
    </div>

    <!-- SECTION: RESET PASSWORD -->
    <div v-if="type === 'reset'" class="auth-section">
      <div class="brand-header text-center">
        <a href="/" class="d-inline-block">
          <b-img :src="logoPath" fluid width="130" alt="Coressy"></b-img>
        </a>
        <h2 class="auth-title">Resetare Parolă</h2>
        <p class="auth-subtitle">Îți vom trimite un link pentru resetarea parolei pe email</p>
      </div>

      <form autocomplete="off" @submit.prevent="reset">
        <div class="custom-form-group">
          <label class="input-label">Adresă E-Mail</label>
          <b-input type="email" v-model="email" placeholder="nume@domeniu.ro" class="custom-input"></b-input>
        </div>

        <div class="action-container mt-4">
          <b-button type="submit" class="btn-apple-primary">
            Trimite Link-ul
          </b-button>
        </div>

        <div class="switch-mode-text text-center mt-3">
          Ți-ai amintit parola?
          <b-link @click="type = 'login'" class="accent-link">Înapoi la autentificare</b-link>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
import Auth from '@/components/auth'
import { bus } from "../../main";
import VFacebookLogin from 'vue-facebook-login-component'

export default {
  name: "AuthModal",
  data() {
    return {
      FB: {},
      fbModel: {},
      scope: {},
      type: 'login',
      email: '',
      password: '',
      c_password: '',
      passwordType: 'password',
      firstName: '',
      lastName: '',
      street: '',
      city: '',
      zip: '',
      phone: '',
      logoPath: process.env.VUE_APP_LOGO_PATH
    }
  },
  components: {
    VFacebookLogin
  },
  methods: {
    togglePassword() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    async login () {
      let authData = {
        email: this.email,
        password: this.password
      }
      let loginResponse = await Auth.login(authData)
      if (loginResponse.success) {
        localStorage.setItem('token', loginResponse.data.token)
        localStorage.setItem('userInfo', JSON.stringify(loginResponse.data.user_data))
        bus.$emit('loggedIn', loginResponse.data.user_data)
        this.$emit('close')
      } else {
        this.$toastr.e('Datele de autentificare nu corespund');
      }
    },
    logout() {
      Auth.logout();
    },
    async register () {
      let registerData = {
        email: this.email,
        password: this.password,
        c_password: this.c_password,
        first_name: this.firstName,
        last_name: this.lastName,
      }
      let registerResponse = await Auth.register(registerData)
      if (registerResponse.success) {
        localStorage.setItem('token', registerResponse.data.token)
        localStorage.setItem('userInfo', JSON.stringify(registerResponse.data.user_data))
        bus.$emit('loggedIn', registerResponse.data.user_data)
        this.$emit('close')
      } else {
        this.$toastr.e('Vă rugăm să completați toate câmpurile obligatorii');
      }
    },
    reset() {
      Auth.resetPassword(this.email).then(response => {
        this.$swal(
            'Verificare Email',
            'Pentru a putea reseta parola vă rugăm să accesați link-ul primit prin E-Mail.',
            'success'
        )
      }).catch(error => {
      })
    },
    handleSdkInit({ FB, scope }) {
      this.FB = FB
      this.scope = scope
    },
    getUserData() {
      this.FB.login(response => {
        if (response.authResponse) {
          this.FB.api('/me?fields=id,name,email', async response => {
            let authData = {
              email: response.email,
              name: response.name,
              password: response.id,
              facebook: true
            }
            let loginResponse = await Auth.login(authData)
            if (loginResponse.success) {
              localStorage.setItem('token', loginResponse.data.token)
              localStorage.setItem('userInfo', JSON.stringify(loginResponse.data.user_data))
              bus.$emit('loggedIn', loginResponse.data.user_data)
              this.$emit('close')
            } else {
              let fbName = response.name.split(" ");
              let registerData = {
                email: response.email,
                password: response.id,
                c_password: response.id,
                first_name: fbName[0],
                last_name: fbName[1],
              }
              let registerResponse = await Auth.register(registerData)
              if (registerResponse.success) {
                localStorage.setItem('token', registerResponse.data.token)
                localStorage.setItem('userInfo', JSON.stringify(registerResponse.data.user_data))
                bus.$emit('loggedIn', registerResponse.data.user_data)
                this.$emit('close')
              }
            }
          });
        } else {
          console.log('User cancelled login or did not fully authorize.');
        }
      });
    },
  },
  mounted() {
    bus.$on("loggedOut", () => {
      if(this.FB && this.FB.logout) {
        this.FB.logout();
      }
    })
  }
}
</script>

<style scoped>
/* Apple Card Container */
.apple-auth-card {
  padding: 24px 20px;
  background-color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #1d1d1f;
  -webkit-font-smoothing: antialiased;
}

/* Header & Logos */
.brand-header {
  margin-bottom: 24px;
}

.auth-title {
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: -0.015em;
  color: #1d1d1f;
  margin-top: 16px;
  margin-bottom: 4px;
}

.auth-subtitle {
  font-size: 0.88rem;
  color: #86868b;
  margin-bottom: 0;
}

/* Form Fields */
.form-row-double {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

@media (max-width: 480px) {
  .form-row-double {
    grid-template-columns: 1fr;
  }
}

.custom-form-group {
  margin-bottom: 16px;
}

.input-label {
  display: block;
  font-size: 0.8rem;
  font-weight: 500;
  color: #6e6e73;
  margin-bottom: 6px;
}

.custom-input {
  width: 100%;
  background-color: #f2f2f7 !important;
  border: 1px solid #e5e5ea !important;
  border-radius: 10px !important;
  color: #1d1d1f !important;
  padding: 10px 14px !important;
  font-size: 0.9rem !important;
  transition: all 0.2s ease !important;
  height: auto !important;
}

.custom-input::placeholder {
  color: #a1a1a6;
}

.custom-input:focus {
  background-color: #ffffff !important;
  border-color: #0071e3 !important;
  box-shadow: 0 0 0 3px rgba(0, 113, 227, 0.15) !important;
  outline: none !important;
}

/* Password Toggle Wrapper */
.password-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.btn-toggle-password {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  font-size: 0.78rem;
  font-weight: 500;
  color: #0071e3;
  cursor: pointer;
  padding: 0;
}

.btn-toggle-password:focus {
  outline: none;
}

/* Links */
.forgot-link {
  font-size: 0.78rem;
  color: #0071e3 !important;
  text-decoration: none !important;
}

.forgot-link:hover {
  text-decoration: underline !important;
}

.switch-mode-text {
  font-size: 0.85rem;
  color: #6e6e73;
}

.accent-link {
  color: #0071e3 !important;
  font-weight: 500;
  text-decoration: none !important;
}

.accent-link:hover {
  text-decoration: underline !important;
}

/* Apple/Tesla Button */
.btn-apple-primary {
  width: 100%;
  background-color: #0071e3 !important;
  border: none !important;
  color: #ffffff !important;
  font-weight: 500 !important;
  font-size: 0.95rem !important;
  padding: 12px 20px !important;
  border-radius: 10px !important;
  transition: all 0.2s ease !important;
  cursor: pointer;
}

.btn-apple-primary:hover {
  background-color: #0077ed !important;
  box-shadow: 0 4px 12px rgba(0, 113, 227, 0.2);
}

.btn-apple-primary:active {
  transform: scale(0.99);
}

/* Divider */
.divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0;
  color: #86868b;
  font-size: 0.78rem;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #e5e5ea;
}

.divider span {
  padding: 0 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Facebook Button Wrapper */
.facebook-wrapper {
  display: flex;
  justify-content: center;
}

::v-deep .custom-fb-btn button {
  border-radius: 10px !important;
  font-family: inherit !important;
  font-size: 0.88rem !important;
  padding: 8px 16px !important;
}
</style>
